/**
 * Contenido del Programa Kit Digital (Red.es / Acelera Pyme).
 * Importes y segmentos según bases reguladoras publicadas; convocatorias sujetas a cambio.
 * Fuentes: acelerapyme.gob.es, red.es
 */

export const KIT_DIGITAL_OFFICIAL_URL = 'https://www.acelerapyme.gob.es/kit-digital';
export const KIT_DIGITAL_CATALOG_URL =
  'https://www.acelerapyme.gob.es/kit-digital/catalogo-digitalizadores';
export const KIT_DIGITAL_SOLUTIONS_URL =
  'https://www.acelerapyme.gob.es/kit-digital/soluciones-digitales';
export const KIT_DIGITAL_PORTAL_URL =
  'https://portal.gestion.sedepkd.red.gob.es/portal/kitdigital';
export const ACCELERA_PYME_PHONE = '900 909 001';

/** Estado general de convocatorias (revisar en web oficial ante cambios). */
export const CONVOCATORIA_NOTICE =
  'Las convocatorias generales del Kit Digital han finalizado. Si ya tienes bono concedido, estás en una convocatoria abierta o quieres preparar tu digitalización, podemos ayudarte a encajar soluciones del catálogo con E-ASY.';

/** Mensaje para landing SEM/SEO (nueva convocatoria). Revisar fechas en Acelera Pyme. */
export const LANDING_CONVOCATORIA_NOTICE =
  'Se prevé la apertura de una nueva convocatoria del Kit Digital. Si vas a solicitar el bono o ya lo tienes concedido, E-ASY —Agente Digitalizador Adherido— te ayuda a elegir e implantar soluciones del catálogo oficial sin perder el importe de tu segmento.';

export const LANDING_CANONICAL = 'https://e-asy.es/kit-digital';

export const LANDING_HIGHLIGHTS = [
  { value: '12.000 €', label: 'bono máximo (segmento I)' },
  { value: 'ADA', label: 'agente adherido Red.es' },
  { value: 'ERP+', label: 'gestión, web y procesos' },
];

export const LANDING_EASY_SOLUTIONS = [
  {
    title: 'ERP y CRM',
    description: 'Gestión de clientes, ventas y operativa en un solo sistema.',
    link: '/vulpin',
  },
  {
    title: 'Web y ecommerce',
    description: 'Presencia online y tienda conectada con tu negocio.',
    link: '/servicios/desarrollo-web-ecommerce',
  },
  {
    title: 'Automatización',
    description: 'Menos tareas repetidas entre administración y operaciones.',
    link: '/vulpin',
  },
  {
    title: 'BI y datos',
    description: 'Cuadros de mando para decidir con información real.',
    link: '/servicios/bi-explotacion-datos',
  },
  {
    title: 'Ciberseguridad',
    description: 'Copias de seguridad, endpoints y comunicaciones seguras.',
    link: '/servicios/ciberseguridad-cumplimiento',
  },
  {
    title: 'Cloud y oficina virtual',
    description: 'Colaboración en la nube y herramientas para equipos remotos.',
    link: '/servicios/infraestructura-cloud-devops',
  },
];

export const LANDING_FAQ = [
  {
    question: '¿Qué es el Kit Digital y quién puede solicitarlo?',
    answer:
      'Es un programa del Gobierno de España, gestionado por Red.es, que subvenciona la contratación de soluciones digitales para pymes, microempresas y autónomos. El beneficiario obtiene un bono digital y lo emplea con Agentes Digitalizadores Adheridos (ADA) del catálogo oficial. Los requisitos concretos dependen de la convocatoria activa.',
  },
  {
    question: '¿Cuánto dinero puedo recibir con el Kit Digital?',
    answer:
      'El importe máximo del bono depende del segmento según empleados: hasta 12.000 € (10–49 empleados), 6.000 € (3–9) y 3.000 € (0–2 empleados/autónomos), además de convocatorias específicas para medianas. Cada categoría de solución tiene además un tope propio dentro de ese bono.',
  },
  {
    question: '¿E-ASY puede implantar mi Kit Digital?',
    answer:
      'Sí. E-ASY figura como Agente Digitalizador Adherido en el catálogo de Red.es. Implantamos ERP/CRM, automatización de procesos, desarrollo web y ecommerce, BI, ciberseguridad y cloud, siempre dentro de las categorías y topes del programa.',
  },
  {
    question: '¿Cómo solicito el bono del Kit Digital?',
    answer:
      'Debes cumplir los requisitos de la convocatoria, registrarte en Acelera Pyme y tramitar la solicitud en los plazos publicados. Una vez concedido el bono, eliges las soluciones del catálogo y un ADA como E-ASY. Te orientamos antes y después de la solicitud.',
  },
  {
    question: '¿El bono del Kit Digital es dinero en efectivo?',
    answer:
      'No. Es un crédito para contratar soluciones digitales del catálogo oficial con un ADA. El importe subvenciona el proyecto acordado (web, CRM, procesos, etc.), no es una transferencia libre.',
  },
  {
    question: '¿Trabajáis con empresas fuera de Canarias?',
    answer:
      'Sí. Tenemos base en Santa Cruz de Tenerife y acompañamos proyectos Kit Digital en Canarias y en el resto de España, con implantación presencial o remota según el alcance.',
  },
];

export const LANDING_SERVICE_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Kit Digital — implantación con Agente Digitalizador E-ASY',
  description:
    'Solicitud e implantación de soluciones Kit Digital para pymes y autónomos: ERP, CRM, web, automatización, BI y ciberseguridad con bono digital de hasta 12.000 €.',
  url: LANDING_CANONICAL,
  serviceType: 'Programa Kit Digital — digitalización subvencionada',
  provider: {
    '@type': 'Organization',
    name: 'E-ASY',
    url: 'https://e-asy.es',
  },
  areaServed: [
    { '@type': 'Country', name: 'España' },
    { '@type': 'AdministrativeArea', name: 'Canarias' },
  ],
  offers: {
    '@type': 'Offer',
    availability: 'https://schema.org/InStock',
    url: LANDING_CANONICAL,
    description: 'Implantación de soluciones Kit Digital con Agente Digitalizador Adherido',
  },
};

export const SEGMENTS = [
  {
    id: 'I',
    label: 'Segmento I',
    employees: 'De 10 a menos de 50 empleados',
    bono: '12.000 €',
  },
  {
    id: 'II',
    label: 'Segmento II',
    employees: 'De 3 a menos de 10 empleados',
    bono: '6.000 €',
  },
  {
    id: 'III',
    label: 'Segmento III',
    employees: 'De 0 a menos de 3 empleados (microempresas y autónomos)',
    bono: '3.000 €',
  },
  {
    id: 'IV-V',
    label: 'Segmentos IV y V',
    employees: 'Medianas empresas (50–250 empleados)',
    bono: '25.000 € / 29.000 €',
    note: 'Convocatorias específicas para empresas de mayor tamaño.',
  },
];

/**
 * Importes máximos de subvención por categoría y segmento (catálogo oficial).
 * No son precios de venta del ADA: son topes del bono que el beneficiario puede destinar.
 */
export const SOLUTION_CATEGORIES = [
  {
    id: 'web',
    title: 'Sitio web y presencia básica en internet',
    description:
      'Página web corporativa, dominio, hosting y presencia digital inicial para dar visibilidad a tu negocio.',
    easy: true,
    link: '/servicios/desarrollo-web-ecommerce',
    amounts: { I: '2.000 €', II: '2.000 €', III: '2.000 €' },
  },
  {
    id: 'ecommerce',
    title: 'Comercio electrónico',
    description:
      'Tienda online con catálogo, pasarela de pago y gestión de pedidos conectada a tu operativa.',
    easy: true,
    link: '/servicios/desarrollo-web-ecommerce',
    amounts: { I: '2.000 €', II: '2.000 €', III: '2.000 €' },
  },
  {
    id: 'redes',
    title: 'Gestión de redes sociales',
    description:
      'Planificación, publicación y seguimiento de redes sociales alineado con tu estrategia comercial.',
    easy: false,
    amounts: { I: '2.500 €', II: '2.500 €', III: '2.000 €' },
  },
  {
    id: 'crm',
    title: 'Gestión de clientes (CRM)',
    description:
      'Seguimiento de oportunidades, clientes y comunicaciones en un único sistema.',
    easy: true,
    link: '/vulpin',
    amounts: { I: '4.000 €', II: '2.000 €', III: '2.000 €' },
    amountNote: 'Usuarios según segmento (catálogo oficial)',
  },
  {
    id: 'bi',
    title: 'Business Intelligence y analítica',
    description:
      'Cuadros de mando e informes para tomar decisiones con datos de ventas, operaciones o finanzas.',
    easy: true,
    link: '/servicios/bi-explotacion-datos',
    amounts: { I: '4.000 €', II: '2.000 €', III: '1.500 €' },
    amountNote: 'Usuarios según segmento (catálogo oficial)',
  },
  {
    id: 'procesos',
    title: 'Gestión de procesos',
    description:
      'Digitalización de flujos internos, expedientes y tareas repetitivas entre departamentos.',
    easy: true,
    link: '/vulpin',
    amounts: { I: '6.000 €', II: '3.000 €', III: '2.000 €' },
    amountNote: 'Usuarios según segmento (catálogo oficial)',
  },
  {
    id: 'factura',
    title: 'Factura electrónica',
    description:
      'Emisión y recepción de facturas electrónicas conforme a la normativa vigente.',
    easy: true,
    link: '/servicios/integraciones-empresariales',
    amounts: { I: '2.000 €', II: '2.000 €', III: '1.000 €' },
    amountNote: 'Usuarios según segmento (catálogo oficial)',
  },
  {
    id: 'oficina',
    title: 'Servicios y herramientas de oficina virtual',
    description:
      'Colaboración en la nube, correo, documentación compartida y trabajo remoto.',
    easy: true,
    link: '/servicios/infraestructura-cloud-devops',
    amounts: { I: '250 €/usuario', II: '250 €/usuario', III: '250 €/usuario' },
    amountNote: 'Máx. usuarios: 49 (Seg. I), 9 (Seg. II), 2 (Seg. III)',
  },
  {
    id: 'comunicaciones',
    title: 'Comunicaciones seguras',
    description:
      'VPN, cifrado y comunicaciones protegidas para equipos distribuidos.',
    easy: true,
    link: '/servicios/ciberseguridad-cumplimiento',
    amounts: { I: '125 €/usuario', II: '125 €/usuario', III: '125 €/usuario' },
    amountNote: 'Máx. usuarios: 48 (Seg. I), 9 (Seg. II), 2 (Seg. III)',
  },
  {
    id: 'ciber',
    title: 'Ciberseguridad',
    description:
      'Copias de seguridad, protección de endpoints y buenas prácticas para reducir riesgos.',
    easy: true,
    link: '/servicios/ciberseguridad-cumplimiento',
    amounts: { I: '125 €/dispositivo', II: '125 €/dispositivo', III: '125 €/dispositivo' },
    amountNote: 'Máx. dispositivos: 48 (Seg. I), 9 (Seg. II), 2 (Seg. III)',
  },
  {
    id: 'presencia-avanzada',
    title: 'Presencia avanzada en internet',
    description:
      'Posicionamiento, analítica web y presencia digital más allá de una web básica.',
    easy: true,
    link: '/servicios/desarrollo-web-ecommerce',
    amounts: { I: '2.000 €', II: '2.000 €', III: '2.000 €' },
  },
  {
    id: 'marketplace',
    title: 'Marketplace',
    description:
      'Presencia y venta a través de marketplaces con integración de catálogo y pedidos.',
    easy: false,
    amounts: { I: '2.000 €', II: '2.000 €', III: '2.000 €' },
  },
];

export const PROCESS_STEPS = [
  {
    step: '1',
    title: 'Diagnóstico y bono',
    description:
      'La empresa debe cumplir requisitos de la convocatoria, registrarse en Acelera Pyme y, si procede, obtener el bono digital. El importe depende del segmento (empleados).',
  },
  {
    step: '2',
    title: 'Elige soluciones y ADA',
    description:
      'Selecciona una o varias categorías del catálogo y un Agente Digitalizador Adherido (ADA), como E-ASY, que figure en el catálogo oficial de Red.es.',
  },
  {
    step: '3',
    title: 'Propuesta y acuerdo',
    description:
      'El ADA te presenta alcance, plazos y coste dentro de los topes de tu bono. Firmáis el acuerdo y se vincula la solución en el portal de gestión del Kit Digital.',
  },
  {
    step: '4',
    title: 'Implantación y justificación',
    description:
      'Se implementa la solución, se valida y se documenta según exige el programa. El bono subvenciona el importe acordado; no es un cheque en mano para gastar libremente.',
  },
];

export const BENEFICIARY_REQUIREMENTS = [
  'Ser pyme, microempresa, autónomo o mediana según la convocatoria activa.',
  'Estar al corriente de obligaciones tributarias y con la Seguridad Social.',
  'No estar en situación de crisis ni incumplir el principio de “no causar perjuicio significativo”.',
  'No figurar como empresa en dificultad según la normativa de ayudas.',
  'Cumplir los requisitos específicos de la convocatoria en la que solicites el bono.',
];

export const FAQ = [
  {
    question: '¿Qué es el Kit Digital?',
    answer:
      'Es un programa del Gobierno de España, gestionado por Red.es, que subvenciona la contratación de soluciones digitales del mercado para mejorar la madurez digital de pymes, microempresas y autónomos. El beneficiario recibe un bono digital y lo emplea con Agentes Digitalizadores Adheridos (ADA) del catálogo oficial.',
  },
  {
    question: '¿Puedo solicitar el bono ahora?',
    answer:
      'Las convocatorias generales han finalizado. Puede haber convocatorias puntuales o plazos para colectivos concretos. Consulta el estado actual en Acelera Pyme. Si ya tienes bono concedido, podemos ayudarte a implantar soluciones con E-ASY.',
  },
  {
    question: '¿E-ASY es Agente Digitalizador?',
    answer:
      'Sí. E-ASY figura como Agente Digitalizador Adherido en el catálogo de Red.es. Puedes comprobarlo en el buscador oficial de digitalizadores y contactarnos para valorar qué categorías encajan con tu negocio.',
  },
  {
    question: '¿El bono son 12.000 € en efectivo?',
    answer:
      'No. Es un crédito para contratar soluciones digitales incluidas en el catálogo, con importes máximos por categoría según tu segmento. El total del bono (por ejemplo 12.000 € en segmento I) es el techo global que puedes distribuir entre las soluciones que contrates.',
  },
  {
    question: '¿Qué soluciones implantáis en E-ASY?',
    answer:
      'Nos centramos en gestión (ERP/CRM), automatización e integración de procesos, desarrollo web y ecommerce, BI, ciberseguridad y cloud. Si tu necesidad encaja con otra categoría del catálogo, lo revisamos en una primera llamada.',
  },
];

export const SERVICE_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Implantación de soluciones Kit Digital',
  description:
    'E-ASY, Agente Digitalizador Adherido al programa Kit Digital: ERP, automatización, web, integraciones y ciberseguridad para pymes y autónomos con bono digital.',
  url: 'https://e-asy.es/solicitud-kit-digital',
  serviceType: 'Digitalización empresarial subvencionada (Kit Digital)',
  provider: {
    '@type': 'Organization',
    name: 'E-ASY',
    url: 'https://e-asy.es',
  },
  areaServed: { '@type': 'Country', name: 'España' },
};
